import { consumeEmailedGuestPaidTrialClaim } from '@/shared/lib/billing/guestPaidTrialClaim';

consumeEmailedGuestPaidTrialClaim();
